import request from '@/utils/request'

export function get(code) {
  const params = {
    code
  }
  return request({
    url: '/dict-detail',
    method: 'get',
    params
  })
}

export function getDictMap(dictCode) {
  const params = {
    dictCode
  }
  return request({
    url: 'dictDetail/list/map',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/dict-detail',
    method: 'post',
    data
  })
}

export function del(id) {
  return request({
    url: '/dict-detail/' + id,
    method: 'delete'
  })
}

export function edit(data) {
  return request({
    url: '/dict-detail',
    method: 'put',
    data
  })
}
